export enum LoginFromTypes {
  VIP = "vip",
  FREE_FOLLOW = "free_follow",
  BUY = "buy"
}

